var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":_vm.span,"offset":_vm.offset,"push":_vm.push,"pull":_vm.pull}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }